import configData from "../config/config";
import store from "../store/index";
import router from "../router/index";
import { piUtRemoveStorage } from "./utils";
/**
 * 图片路径补上固定一段
 * @param value url
 * @returns url
 */
export const piAhFileUrl = (value) => {
    if (value && value.indexOf("http") == 0) {
        return value;
    }
    else if (value && typeof value !== "undefined") {
        return configData.fileImg + value;
    }
    return "";
};
/**
 * 返回上一页 ，在多次跳转中，返回的不一定是你想返回的页面，比如新增要返回列表，经过多次跳转，
 * 直接返回不到列表，就在store保存的历史路由找一找（因为可能带参数）
 * @param route  this.$route
 * @param goBackUrl  要返回到的URL
 */
export const piAhGoBack = (route, goBackUrl) => {
    const win = window;
    store.commit("urlRemoveRouter", route.path);
    if (goBackUrl) {
        let goUrl = "";
        const state = store.state; // eslint-disable-line
        const goRouterList = state.sys.goRouterList;
        const goRouter = state.sys.goRouter;
        if (goRouterList.length > 1) {
            const upper = goRouterList[goRouterList.length - 2].url;
            if (upper == goBackUrl) {
                // 如果是正常父子页面进入返回的流程（经过历史的倒数第二个 == 传入的url），返回空，执行浏览器的返回事件
                goUrl = "";
            }
            else {
                // 如果不是正常浏览，就对比找出已经缓存的url组件的路径，因为上一页有可能带参数,如果已经被干掉，就返回传入的 url
                goRouter.map((item) => {
                    if (item.url == goBackUrl) {
                        goUrl = item.fullPath;
                    }
                });
            }
        }
        if (goUrl == "") {
            win.history.go(-1);
        }
        else {
            router.push(goUrl);
        }
    }
    else {
        win.history.go(-1);
    }
    piUtRemoveStorage(route.path);
};
/**
 * 把列表中的 null 转成 - ，一般表格用到
 * @param tableList 列表
 * @param notHandled  不处理的字段
 * @returns 处理过的列表
 */
export const piAhForTableList = (tableList, notHandled) => {
    if (tableList) {
        const list = [];
        tableList.map((item) => {
            const itemData = {};
            for (const i in item) {
                // notHandled 不处理的字段
                itemData[i] =
                    item[i] || item[i] == 0 || (notHandled && notHandled.indexOf(i) != -1)
                        ? item[i]
                        : "-";
            }
            list.push(itemData);
        });
        return list;
    }
    else {
        return [];
    }
};
/**
 * 获取路由中的权限
 * @param route this.$route
 * @returns 权限
 */
export const piAhGetPrivilegeVoObj = (route) => {
    return route.meta && route.meta.privilegeVoObj
        ? route.meta.privilegeVoObj
        : {};
};
/**
 * 退出登录，删除登录并刷新
 */
export const piAhOut = () => {
    piUtRemoveStorage();
    const win = window;
    const state = store.state; // eslint-disable-line
    const userInfo = state.sys.userInfo;
    if (configData.loginUrl) {
        win.location.href = configData.loginUrl + "?oprPkId=" + userInfo.oprPkId;
    }
    else {
        win.location.href =
            win.location.origin +
                configData.host +
                "/#/login?oprPkId=" +
                userInfo.oprPkId;
        win.history.go(0);
    }
};
/**
 * 重置 form,一般用在表格数据请求的时候 参数 对象变 {} 数组变 [] 字符串变 ''
 * @param form
 * @returns
 */
export const piAhResetForm = (form) => {
    for (const i in form) {
        if (i != "oprPkId" && i != "globalPageSize") {
            if (typeof form[i] == "string" || typeof form[i] == "number") {
                form[i] = "";
            }
            else if (Array.isArray(form[i])) {
                form[i] = [];
            }
            else if (typeof form[i] == "object") {
                form[i] = {};
            }
        }
    }
    form.globalPageIndex = 1;
    return form;
};
